import React from 'react';
import { CustomThemeProvider } from '../../ThemeContext';
import { NotificationProvider } from '../../context/NotificationContext';
import { AdminAuthProvider } from '../context/AdminAuthContext';
import AdminAccessGate from '../admin-auth/access-code/AdminAccessGate';
import { ControlPanelBrandingProvider } from '../context/control-panel/ControlPanelBrandingContext';
import AdminRoutes from '../routes/AdminRoutes';
import AppToastHost from '../../components/toast/AppToastHost';

const AdminHostApp = () => (
  <NotificationProvider>
    <CustomThemeProvider>
      <AdminAccessGate>
        <AdminAuthProvider>
          <ControlPanelBrandingProvider>
            <AdminRoutes />
            <AppToastHost />
          </ControlPanelBrandingProvider>
        </AdminAuthProvider>
      </AdminAccessGate>
    </CustomThemeProvider>
  </NotificationProvider>
);

export default AdminHostApp;
